import React from 'react';
import {
  
  Chip
} from '@mui/material';
import { 
  List,
  ListItem,
  ListItemIcon,
  ListItemText,Divider, Button, Box, Typography, Drawer } from '@barracuda-internal/bds-core';
import InsightsIcon from '@mui/icons-material/Insights';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SecurityIcon from '@mui/icons-material/Security';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

export default function AiInsightsDrawer({ open, onClose, ai_summary }) {
  if (!ai_summary) return null;
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: '40vw', maxWidth: 600, minWidth: 350, p: 0, boxShadow: 6 }
      }}
    >
      <Box role="presentation" sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', alignItems: 'center', mb: 1   }}>
          
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            <InsightsIcon color="primary" fontSize="large" style={{margin:2}}/>
            AI Security Insights
          </Typography>
            <IconButton aria-label="close" onClick={onClose} sx={{ color: '#d1d3d5ff' }}>
                <CloseIcon />
            </IconButton>
        </Box>
        <Divider />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Risk Pattern
          </Typography>
          <Typography variant="body1" dangerouslySetInnerHTML={{ __html: ai_summary.RiskPattern }} />
        </Box>
        <Divider />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            AI Confidence
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Chip icon={<SecurityIcon />} label={`Confidence: ${ai_summary?.AIConfidence?.confidence_score}`} color="success" />
            <Chip icon={<WarningAmberIcon />} label={`Attack Probability: ${ai_summary?.AIConfidence?.attack_probability}`} color="warning" />
          </Box>
          <Typography variant="body2" sx={{ mt: 1 }} dangerouslySetInnerHTML={{ __html: ai_summary?.AIConfidence?.reasoning }} />
        </Box>
        <Divider />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Critical Findings
          </Typography>
          <List>
            {ai_summary?.CriticalFindings?.map((finding, idx) => (
              <ListItem key={idx} alignItems="flex-start" sx={{ mb: 1, borderRadius: 2, background: '#fff7f0', boxShadow: 1 }}>
                <ListItemIcon>
                  <WarningAmberIcon color={finding.severity === 'High' ? 'error' : 'warning'} />
                </ListItemIcon>
                <ListItemText
                  disableTypography={true}
                  primary={<span style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: finding.finding }} />}
                  secondary={
                    <div>
                      <Typography component="span" variant="body2" color="text.secondary" dangerouslySetInnerHTML={{ __html: finding?.impact }} />
                      <Box sx={{ mt: 0.5, display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Chip size="small" label={`Severity: ${finding?.severity}`} color={finding?.severity === 'High' ? 'error' : 'warning'} />
                        <Chip size="small" label={`CVSS: ${finding?.cvss_score}`} color="info" />
                      </Box>
                    </div>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
        <Divider />
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
            Recommended Actions
          </Typography>
          <List>
            {ai_summary?.RecommendedActions?.map((action, idx) => (
              <ListItem key={idx}>
                <ListItemIcon>
                  <CheckCircleIcon color="success" />
                </ListItemIcon>
                <ListItemText primary={<span dangerouslySetInnerHTML={{ __html: action }} />} />
              </ListItem>
            ))}
          </List>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
      </Box>
    </Drawer>
  );
}
